module.exports = __webpack_public_path__ + "img/android4icon2.9892a2ac.png";